
export enum MySubscriptionTabEnum {
    InformationServicse = 1,
    PscRiskIQ = 2
}

export enum SubscriptionInformationServicesTabEnum {
    MyVessels = 1,
    VesselChanges = 2,
    MyCompanies = 3,
    CompanyChanges = 4
}